import BadgeListDesktop1XP from '../../BadgeList1XP/BadgeListDesktop1XP.vue';
import type { ValueOf } from '../../../types/helper';
import type { StoreNavigationFooter } from '../../../types/footer';

export const mapBadges = (config?: StoreNavigationFooter['config']) =>
  config?.pt_footer_shop_badges?.value?.map((badge) => ({
    title: badge.st_title,
    text: badge.st_text,
    image: `${badge.st_image?.resolutionsMetaData?.ORIGINAL?.url}` || `${badge.st_image?.url}`,
  })) satisfies ValueOf<typeof BadgeListDesktop1XP>['items'];
